import { styled } from '@linaria/react';

export const Layout = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f8f9fa;
`;

export const MainContent = styled.div`
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;